var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 35C51.725 31.35 55.5 26.975 55.5 21.25C55.5 17.6033 54.0513 14.1059 51.4727 11.5273C48.8941 8.94866 45.3967 7.5 41.75 7.5C37.35 7.5 34.25 8.75 30.5 12.5C26.75 8.75 23.65 7.5 19.25 7.5C15.6033 7.5 12.1059 8.94866 9.52728 11.5273C6.94866 14.1059 5.5 17.6033 5.5 21.25C5.5 27 9.25 31.375 13 35L30.5 52.5L48 35Z",
    stroke: "#4B286D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigHeart);
export default __webpack_public_path__ + "static/media/big-heart.f6a7313a520096fca073ea55b4ddd333.svg";
export { ForwardRef as ReactComponent };